import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import FieldGroup from '../field_group/FieldGroup';
import PaginateSelect from '../field_group/PaginateSelect';
import Form from '../form/Form';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';
import { searchZoneByText } from '../../redux/zone/zone_actions';

const azimuthValidator = value => {
  return value >= 0 && value <= 359;
};

export class EnvelopDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
    this.state = {
      azimuth_angle: null,
    };
  }

  getEnvelopData() {
    return this.formRef.getFormData();
  }

  renderOption(item) {
    const { t } = this.props;
    return (
      <option key={item.id} value={item.id}>
        {t(item.name)}
      </option>
    );
  }

  renderTTV(fieldErrors, customAttr) {
    const { type, TTV } = this.props.envelop;
    return (
      type.toLocaleLowerCase() === 'roof' ?
      <FieldGroup
        id="envelop-RTTV"
        field="RTTV"
        type="number"
        label={<span>RTTV</span>}
        value={TTV}
        {...customAttr}
        readOnly={true}
        disabled={true}
      />
      :
      <FieldGroup
        id="envelop-OTTV"
        field="OTTV"
        type="number"
        label={<span>OTTV</span>}
        value={TTV}
        {...customAttr}
        readOnly={true}
        disabled={true}
      />
    );
  }

  renderAzimuth(t, azimuth_angle, fieldErrors, customAttr) {
    const azimuth_placeholder = 80;
    const norm_azimuth_angle = azimuth_angle === undefined ? azimuth_placeholder : (parseInt(azimuth_angle, 10) % 360);
    const azimuthOptions = [
      { label: t('south'), range: [0, 0] },
      { label: t('south west'), range: [1, 89] },
      { label: t('west'), range: [90, 90] },
      { label: t('north west'), range: [91, 179] },
      { label: t('north'), range: [180, 180] },
      { label: t('north east'), range: [181, 269] },
      { label: t('east'), range: [270, 270] },
      { label: t('south east'), range: [271, 359] },
    ];

    const option = azimuthOptions.filter(
        ({ range: [start, end] }) => norm_azimuth_angle >= start && norm_azimuth_angle <= end
      ).pop() || azimuthOptions.pop();
    return (
      <FieldGroup
        id="envelop-azimuth"
        field="azimuth_angle"
        type="number"
        label={`${t('azimuth angle')} (°)`}
        placeholder={`${azimuth_placeholder}`}
        value={azimuth_angle}
        min={0}
        max={359}
        style={{ zIndex: 'initial' }}
        validators={[requiredValidator, azimuthValidator]}
        errorMessage={getErrorValue(fieldErrors, 'azimuth_angle')}
        addonMsg={option.label}
        help={t('azimuth_help_msg')}
        onValueChange={value => this.setState({ azimuth_angle: value })}
        {...customAttr}
      />
    );
  }

  render() {
    const {
      name,
      zone_id,
      zone_name,
      type,
      azimuth_angle,
      inclination,
      WWR,
      description,
      image,
    } = this.props.envelop || {};
    const { isShowWWR, listZone, disabled, fieldErrors, t, ...otherAttr } = this.props;
    const customAttr = { disabled };

    const zoneOptions = zone_id ? [{ value: zone_id, label: zone_name }] : [];

    return (
      <Form
        {...otherAttr}
        showThumbnail={false}
        image={image}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
        ref={ref => (this.formRef = ref)}
      >
        <FieldGroup
          id="envelop-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="envelop-type"
          field="type"
          componentClass="select"
          label={t('type')}
          value={type && type.toLowerCase()}
          defaultDirty={true}
          errorMessage={getErrorValue(fieldErrors, 'type')}
          {...customAttr}
          readOnly={!!(this.props.envelop && this.props.envelop.id)}
          disabled={!!(this.props.envelop && this.props.envelop.id)}
        >
          {this.props.envelopTypeList.map(type => this.renderOption(type))}
        </FieldGroup>
        <FieldGroup
          id="zone"
          componentClass={PaginateSelect.TYPE_NAME}
          field="zone_id"
          label={t('zone')}
          value={zone_id}
          defaultDirty={true}
          loadOptions={listZone}
          options={zoneOptions}
          isDisabled={this.props.envelop && !this.props.envelop.id && zone_id}
        />
        {this.renderAzimuth(t, this.state.azimuth_angle || azimuth_angle, fieldErrors, customAttr)}
        <FieldGroup
          id="envelop-inclination"
          field="inclination"
          type="number"
          label={`${t('inclination')} (°)`}
          placeholder="15"
          value={inclination}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'inclination')}
          {...customAttr}
        />
        {this.props.envelop && this.props.envelop.id && this.renderTTV(fieldErrors, customAttr)}
        {isShowWWR && (<FieldGroup
            id="envelop-WWR"
            field="WWR"
            type="number"
            label={t('WWR')}
            placeholder="1000"
            value={WWR}
            errorMessage={getErrorValue(fieldErrors, 'WWR')}
            {...customAttr}
            disabled={true}
          />)
        }
        <FieldGroup
          id="envelop-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

EnvelopDetail.defaultProps = {
  isShowWWR: false,
};

const mapStateToProps = state => ({
  envelopTypeList: state.reference.envelop.envelopTypeList,
});

const mapDispatchToProps = (dispatch, { building }) => ({
  listZone: (searchValue, page) => {
    return searchZoneByText(searchValue, building.id, page)
      .then(resp => resp.data.map(option => ({value: option.id, label: option.name})))
  },
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(EnvelopDetail),
);



// WEBPACK FOOTER //
// ./src/components/envelop/EnvelopDetail.js